// Injeção do código base do Google Analytics
const appendGoogleAnalyticsTrackingCode = () => {
  try {
    const scriptBaseOne = window.document.createElement('script');
    scriptBaseOne.src = `https://www.googletagmanager.com/gtag/js?id=G-SKS56C309N`;
    scriptBaseOne.async = true;

    const scriptBaseTwo = document.createElement('script');
    scriptBaseTwo.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-SKS56C309N');
      `;

    document.head.appendChild(scriptBaseOne);
    document.head.appendChild(scriptBaseTwo);
  } catch (error) {
    console.error('Erro ao injetar analytics:', error);
  }
};

export default appendGoogleAnalyticsTrackingCode;
